<template>
  <v-navigation-drawer v-bind="$attrs" touchless stateless permanent clipped ref="drawer">
    <v-list v-if="title || back_ref">
      <v-list-item>
        <!-- <v-list-item-avatar v-if="back_ref"><v-btn icon :to="back_ref" x-large><v-icon>mdi-chevron-left</v-icon></v-btn></v-list-item-avatar> -->
        <v-list-item-title><h2>{{ title }}</h2></v-list-item-title>
      </v-list-item>
    </v-list>
    
    <v-divider v-if="title || back_ref"></v-divider>

    <v-list dense max-height="calc(100vh - 140px)" style="overflow-y: auto">
      <v-list-item v-for="(item, idx) in items" :key="idx" link :to="item.link">
        <v-list-item-avatar>
          <v-badge
            color="error"
            overlap
            dot
            left
            :value="item.badge"
            
          >
            <v-icon>{{ item.icon }}</v-icon>
          </v-badge>
        </v-list-item-avatar>
        <v-list-item-title>{{ item.text }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  props: {
    title: String,
    back_ref: String,
    items: Array
  },
  methods:{
    onScroll() {
      this.$refs.drawer.$el.style.paddingTop = `${document.documentElement.scrollTop || document.body.scrollTop}px`
    }
  },
  mounted(){
    this.onScroll()
    window.addEventListener('scroll', this.onScroll)
  },
  beforeDestroy(){
    window.removeEventListener('scroll', this.onScroll)
  }
}
</script>